import { createContext, useCallback, useContext, useRef, useState } from "react";
import { AlertCircle, CheckCircle2 } from "lucide-react";

const ToastCtx = createContext(() => {});

export function ToastProvider({ children }) {
  const [toast, setToast] = useState(null);
  const timer = useRef(null);
  const show = useCallback((msg, kind = "success") => {
    if (timer.current) clearTimeout(timer.current);
    setToast({ msg, kind, id: Date.now() });
    timer.current = setTimeout(() => setToast(null), 2500);
  }, []);
  const bg = toast?.kind === "error" ? "bg-[#EB5757] text-white" : toast?.kind === "info" ? "bg-white text-[#121212]" : "bg-[#27AE60] text-white";
  const Icon = toast?.kind === "error" ? AlertCircle : CheckCircle2;
  return (
    <ToastCtx.Provider value={show}>
      {children}
      {toast && (
        <div
          key={toast.id}
          role="status"
          aria-live="polite"
          className={`pointer-events-none fixed bottom-24 left-1/2 z-[60] flex w-[calc(100%-32px)] max-w-md items-center gap-2 rounded-xl p-4 shadow-2xl lg:bottom-8 ${bg}`}
          style={{ animation: "toastIn .25s ease-out both", transform: "translateX(-50%)" }}
        >
          <Icon className="h-5 w-5 shrink-0" aria-hidden />
          <span data-testid="toast-message" className="flex-1 whitespace-pre-line text-sm font-medium">
            {toast.msg}
          </span>
        </div>
      )}
    </ToastCtx.Provider>
  );
}

export const useToast = () => useContext(ToastCtx);
